export enum Path {
  Benefits = '/benefits/',
  MyAccount = '/my-account/',
  MyAccountCancellation = '/my-account/cancellation/',
  MyAccountCancelMembership = '/my-account/cancel-membership/',
}
